import React from "react";
import DialogContent from "@mui/material/DialogContent";
import {
  Box,
  DialogActions,
  Dialog as DialogContainer,
  useTheme,
} from "@mui/material";
import ActionButton from "./ActionButton";
import { Base } from ".";

interface Props {
  title: string;
  open: boolean;
  cancelText?: string;
  handleCancel: () => void;
  confirmText: string;
  confirmButtonType: "primary" | "delete";
  handleConfirm: () => void;
  loading: boolean;
}

const Dialog: React.FC<Props> = (props) => {
  const {
    title,
    open,
    cancelText,
    handleCancel,
    confirmText,
    confirmButtonType,
    handleConfirm,
    loading,
  } = props;
  const theme = useTheme();

  return (
    <DialogContainer open={open} fullWidth>
      {title && (
        <Box
          sx={{
            paddingTop: "10px",
            paddingX: "10px",
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <Base.Text text={title} variant="h3" center />
        </Box>
      )}
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <DialogActions sx={{ display: "flex", justifyContent: "space-around" }}>
          <ActionButton
            text={cancelText || "Cancel"}
            type="secondary"
            onClick={handleCancel}
          />
          <ActionButton
            text={confirmText}
            type={confirmButtonType}
            disabled={loading}
            onClick={handleConfirm}
          />
        </DialogActions>
      </DialogContent>
    </DialogContainer>
  );
};

export default Dialog;
